export const uk = {
    'experiments-archive-message-multiply':
        '{experimentsList} были перенесены в архив в Яндекс.Аудиториях. Исключите заархивированные эксперименты из списка активных.',
    'experiments-archive-message-single':
        '{experimentsList} был перенесен в архив в Яндекс.Аудиториях. Исключите заархивированный эксперимент из списка активных.',
    'show-only-selected': 'Показать только выбранные',
    subtitle: 'Для одной кампании укажите не более 5 экспериментов',
    title: 'Настройка экспериментов'
};
